import React from "react";
import styles from "./index.module.scss";

const Message = ({ text }) => {
  return <div className={styles.message}>{text}</div>;
};

export default Message;
